import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Sidebar from "./Sidebar";
import ProfileMenu from "./UserProfileMenu";
import testManagerLogo from "./../images/test_manager_logo.png";
import kpitLogo from "./../images/kpit_logo_new.png";
import automateKPILogo from "./../images/automate_kpi_icon.png";
import "./menuIcon.css";
import "./Navbar.css";
import PropTypes from "prop-types";
import LocTok from '../authComponents/uTk';

class Landing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openSideMenu: false,
    };
    this.transformIcon = this.transformIcon.bind(this);
  }
  logOut(e) {
    e.preventDefault();
    let storedTk = new LocTok();
    if(!storedTk.isLocTokValid()){
        storedTk.clearSession();
    }else{
        storedTk.getTksFrmLoc();
        storedTk.logout();
    }
  }

  showSideBarFun(){
    this.setState({
        openSideMenu: true
      });
  }
  transformIcon(e) {
    e.preventDefault();
     this.setState({
       openSideMenu: false,
     });
  }
  //  class Landing extends Component {
  //   constructor(props){
  //       super(props)
  //       this.state = {
  //         openSideMenu : false
  //       }
  //      this.transformIcon = this.transformIcon.bind(this)
  //   }
  //   logOut(e) {
  //     e.preventDefault()
  //     this.setState({
  //         openSideMenu : false
  //     })
  //     localStorage.removeItem('userToken')
  //     this.props.history.push(`/`)
  //   }

  //  transformIcon(e){
  //      e.preventDefault()
  //      if(this.state.openProfileMenu === true){
  //          this.setState({
  //              openSideMenu : !this.state.openSideMenu
  //          })
  //      }
  //      else{
  //      this.setState({
  //          openSideMenu : !this.state.openSideMenu
  //      })
  //     }

  //  }

  render() {
    const userLink = (
      <div className="collapse navbar-collapse" id="navbarNavDropdown">
        <ul className="navbar-nav" style={{display: 'none'}}>
          <li className="nav-item dropdown">
            <ul className="navbar-nav">
              <li
                className="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Action
              </li>
              {
                (window.location.pathname.includes("/open_loop") === true)?
                  <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                    <li className="dropdown-item" href="#">
                      <Link to="/view_scenario" className="nav-link">
                        View Scenarios(Open Loop)
                      </Link>
                    </li>
                    <li className="dropdown-item" href="#">
                      <Link to="/scenario_group" className="nav-link" >
                          View Scenario Group(Open Loop)
                      </Link>
                    </li>
                    <li className="dropdown-item" href="#">
                      <Link to="/upload_file" className="nav-link" >
                        Scheduler(Open Loop)
                      </Link>
                    </li>
                    <li className="dropdown-item" href="#">
                      <Link to="/testRunStatus" className="nav-link" >
                        Testrun Status(Open Loop)
                      </Link>
                    </li>
                    </div>
                    :
                  <div className="dropdown-menu" aria-labelledby="navbarDropdown">

                    <li className="dropdown-item" href="#">
                        <Link to="/close_loop_view_scenario" className="nav-link" >
                          View Scenario(Close Loop)
                        </Link>
                    </li>
                      <li className="dropdown-item" href="#">
                        <Link to="/close_loop_scenario_group" className="nav-link" >
                          View Scenario Group(Close Loop)
                        </Link>
                    </li>
                    <li className="dropdown-item" href="#">
                        <Link to="/close_loop_scenario_collection" className="nav-link" >
                          View Base Scenario Collection(Close Loop)
                        </Link>
                    </li>
                    <li className="dropdown-item" href="#">
                        <Link to="/close_loop_scenario_collection_enhanced" className="nav-link" >
                          View Base Scenario Collection enhanced(Close Loop)
                        </Link>
                    </li>
                    <li className="dropdown-item" href="#">
                        <Link to="/close_loop_custom_map_listings" className="nav-link" >
                          View Custom Maps(Close Loop)
                        </Link>
                    </li>
                    <li className="dropdown-item" href="#">
                        <Link to="/close_loop_ad_client_listings" className="nav-link" >
                          View AD Client(Close Loop)
                        </Link>
                    </li>
                    <li className="dropdown-item" href="#">
                        <Link to="/close_loop_scheduler" className="nav-link" >
                          Scheduler(Close Loop)
                        </Link>
                      </li>
                    <li className="dropdown-item" href="#">
                        <Link to="/close_loop_test_run_status" className="nav-link" >
                          Testrun Status(Close Loop)
                        </Link>
                      </li>
                      <li className="dropdown-item" href="#">
                        <Link to="/close_loop_test_run_status_Revised" className="nav-link" >
                          Testrun Status Revised(Close Loop)
                        </Link>
                      </li>
                  <li className="dropdown-item" href="#">
                    <Link to="/scenario_file/upload" className="nav-link" >
                      Scenario File(s) Upload
                    </Link>
                  </li>
                  <li className="dropdown-item" href="#">
                    <Link to="/map_ad/upload" className="nav-link" >
                      Scenario Map and AD client Upload
                    </Link>
                  </li>
                  <li className="dropdown-item" href="#">
                    <Link to="/scenario_group/bulk_creation" className="nav-link" >
                      Bulk Scenario Group
                    </Link>
                  </li>
                  <li className="dropdown-item" href="#">
                    <Link to="/scenario_variation/upload" className="nav-link" >
                      Scenario Variation Upload
                    </Link>
                  </li>
                  <li className="dropdown-item" href="#">
                    <Link to="/kpi_manager" className="nav-link" >
                      KPI Selector
                    </Link>
                  </li>
                </div>
              }
            </ul>
          </li>
          <li className="nav-item dropdown">
            <ul className="navbar-nav">
              <li
                className="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Dashboard
              </li>
              <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                <li className="dropdown-item" href="#">
                  <Link to="/close_loop/individual/kpi/dashboard" className="nav-link">
                      KPI Dashboard
                  </Link>
                </li>
                {/* <li className="dropdown-item" href="#">
                  <Link to="/close_loop/performance_report" className="nav-link">
                    Performance Dashboard
                  </Link>
                </li> */}
                <li className="dropdown-item" href="#">
                  <Link to="/close_loop/artifact_dashboard" className="nav-link">
                    Artifact Dashboard
                  </Link>
                </li>
                <li className="dropdown-item" href="#">
                  <Link to="/apm_dashboard" className="nav-link" >
                     APM Dashboard
                   </Link>
                </li>
                <li className="dropdown-item" href="#">
                  <Link to="/close_loop/real_time/apm/dashboard" className="nav-link" >
                     Docker stats
                   </Link>
                </li>
              </div>
            </ul>
          </li>
          {/* <li className="nav-item dropdown">
            <li className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Execution
            </li>
            <div className="dropdown-menu" aria-labelledby="navbarDropdown">
              <li className="dropdown-item" href="#">
                <Link to="/close_loop/topology" className="nav-link">
                    Topology Handler
                </Link>
              </li>
            </div>
          </li> */}
        </ul>
        <ul className="navbar-nav ml-auto">
          <li className="nav-item dropdown">
            <ul className="navbar-nav">
               <a
                 className="nav-link dropdown-toggle"
                 href="#"
                 id="navbarDropdownMenuLink"
                 role="button"
                 data-toggle="dropdown"
                 aria-haspopup="true"
                 aria-expanded="false"
               >
                 <i className="fas fa-user-lock"></i>
               </a>
               <div
                 className="dropdown-menu dropdown-menu-right"
                 aria-labelledby="navbarDropdownMenuLink"
               >
                 <li className="dropdown-item">
                   <Link to="/profile" className="nav-link">
                     <i className="fas fa-user-circle"></i> Profile
                   </Link>
                 </li>
                 <li className="dropdown-item">
                   <a className="nav-link" onClick={this.logOut.bind(this)}>
                     <i className="fa fa-power-off"></i>  Logout
                   </a>
                 </li>
               </div>
            </ul>
          </li>
        </ul>
      </div>
    );

    return (
      <div className="cus-navbar">
        <nav className="navbar navbar-expand-lg navbar-light">
          <React.Fragment>
              { !this.state.openSideMenu ?
                  (
                      <li className="navbar cus-nav-icon" style={{display:"none"}} onClick={ () => this.showSideBarFun()}type="button">
                          <span className="navbar-toggler-icon"></span>
                      </li>
                  ) : null
               }
              {window.location.pathname.includes("/welcome_kpi_dashboard") ===
                true ||
              window.location.pathname.includes(
                "/welcomeautomatekpi/landingkpidashboard"
              ) === true ||
              window.location.pathname.includes("/camera_dashboard_level2") ===
                true ||
              window.location.pathname.includes("/camera_dashboard_level3") ===
                true ||
              window.location.pathname.includes("/welcomeautomatekpi") ===
                true ? (
                <li
                  className="navbar-brand"
                  href="#"
                  style={{ padding: "0", cursor: "pointer" }}
                >
                  <li className="navbar-brand" href="#">
                    <Link style={{ textDecoration: "none" }} to="/navigate_new">
                      <img src={kpitLogo} alt="" height="30" />
                    </Link>
                  </li>
                  <li className="navbar-brand" href="#">
                    <Link to="/welcomeautomatekpi">
                      <img
                        src={automateKPILogo}
                        height="30"
                        className="d-inline-block align-top"
                        alt=""
                      ></img>
                    </Link>
                  </li>
                </li>
              ) : (
                  <li className="navbar-brand" href="#">
                    <Link to="/navigate_new">
                      <img
                        src={testManagerLogo}
                        height="30"
                        className="d-inline-block align-top"
                        alt=""
                      ></img>
                    </Link>
                  </li>
              )}
          </React.Fragment>
          <li
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </li>
          { userLink }
        </nav>
        {this.state.openSideMenu ? (
          <Sidebar handleClick={this.transformIcon.bind(this)} />
        ) : (
          ""
        )}
        {this.state.openProfileMenu ? (
          <ProfileMenu
            closeOnClick={this.handleProfileMenu.bind(this)}
            logoutOnClick={this.logOut.bind(this)}
          />
        ) : (
          ""
        )}
      </div>
    );
  }
}

Landing.propTypes = {
  history: PropTypes.string,
};

Landing.defaultProps = {
  history: []
};

export default withRouter(Landing);